module.exports = __webpack_public_path__ + "img/steiger2.d75db30d.jpg";